/* Control de EPP: EPP que recibió el usuario, con la fecha estimada de reposición
 * de cada uno. Los vigentes arriba; abajo el historial. */
import { IonContent, IonPage } from "@ionic/react";
import { useEffect, useState } from "react";
import Header from "src/components/Header";
import { AnticipadaInfo, Cargando, DetalleEntregaDialog, EstadoChip, useToastEpp } from "src/components/epp/EppComunes";
import EppAPI, { LineaEntrega, etiquetaItem, fechaCorta, plural } from "src/services/epp";
import "./Epp.css";

const Fila: React.FC<{ l: LineaEntrega; onVer: () => void }> = ({ l, onVer }) => (
  <div className="epp-fila" onClick={onVer} style={{ cursor: "pointer" }}>
    <div className="epp-fila-cabecera">
      <span className="epp-item">{l.Cantidad} × {etiquetaItem(l.Item, l.Talle)}</span>
      <EstadoChip estado={l.Estado} etiqueta={l.EstadoEtiqueta} />
    </div>
    <div className="epp-meta">
      <span>Recibido {fechaCorta(l.Fecha)}</span>
      <span>Reposición {fechaCorta(l.FechaReposicion)}</span>
      {l.DiasRestantes !== null && l.DiasRestantes >= 0 && <span>Faltan {plural(l.DiasRestantes, "día", "días")}</span>}
    </div>
    {l.Anticipada && <AnticipadaInfo motivo={l.Motivo} estado={l.Estado} />}
  </div>
);

const EppMisEpp: React.FC = () => {
  const toast = useToastEpp();
  const [lineas, setLineas] = useState<LineaEntrega[] | null>(null);
  const [entregaId, setEntregaId] = useState<number | null>(null);

  useEffect(() => {
    EppAPI.misEpp()
      .then(setLineas)
      .catch((err) => {
        setLineas([]);
        toast.error(err, "No se pudieron cargar tus EPP");
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const vigentes = (lineas || []).filter((l) => l.Vigente);
  const historial = (lineas || []).filter((l) => !l.Vigente);

  return (
    <IonPage>
      <Header titulo="Mis EPP" />
      <IonContent id="epp-mis-epp">
        <div className="epp-page">
          {lineas === null && <Cargando />}
          {lineas?.length === 0 && <div className="epp-vacio">Todavía no recibiste EPP registrados en la app.</div>}
          {vigentes.length > 0 && (
            <div className="epp-card">
              <p className="epp-card-titulo">En uso</p>
              {vigentes.map((l) => <Fila key={l.Id} l={l} onVer={() => setEntregaId(l.EntregaId)} />)}
            </div>
          )}
          {historial.length > 0 && (
            <div className="epp-card">
              <p className="epp-card-titulo">Historial</p>
              {historial.map((l) => <Fila key={l.Id} l={l} onVer={() => setEntregaId(l.EntregaId)} />)}
            </div>
          )}
        </div>
        <DetalleEntregaDialog entregaId={entregaId} onClose={() => setEntregaId(null)} />
      </IonContent>
    </IonPage>
  );
};

export default EppMisEpp;
